import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { isAxiosError } from 'axios'
import styled from 'styled-components'

import { QUERY_KEY } from '../../../constants'

import { toast } from '../../../utils'

import { getDepositAccount } from '../../../api/depositAccount'

import { AlignCenterItem, RowBetween, ColumnItem } from '../../../components/common'
import { Text } from '../../../components/text'
import { Button } from '../../../components/button'
import { DivideLine } from '../../../components/divide'
import { BankIcon } from '../../../components/bankIcon'
import { Spinner } from '../../../components/spinner/Spinner'

import { Color } from '../../../theme/color'

export function Deposit() {
  const depositAccount = useQuery({ queryKey: [QUERY_KEY.depositAccount], queryFn: getDepositAccount })

  useEffect(() => {
    if (depositAccount.isError && depositAccount.error) {
      if (isAxiosError(depositAccount.error)) {
        toast(depositAccount.error.response?.data.message, depositAccount.error)
      }
    }
  }, [depositAccount.isError, depositAccount.error])

  if (depositAccount.isPending || depositAccount.isError) {
    return (
      <AccountInfoWrap>
        <AccountCard>
          <Spinner />
        </AccountCard>
      </AccountInfoWrap>
    )
  }

  return (
    <AccountInfoWrap>
      <AccountCard>
        <RowBetween>
          <AlignCenterItem $gap={8}>
            <BankIcon name="NH농협은행" size={24} />
            <Text size={16} weight={500} lineHeight={24}>
              NH농협은행
            </Text>
          </AlignCenterItem>
          <Text size={14} lineHeight={22} color="text_secondary">
            {depositAccount.data.account}
          </Text>
        </RowBetween>
        <DivideLine />
        <UserAccountInfo>
          <Text size={14} lineHeight={22}>
            <Text size={14} weight={600}>
              {depositAccount.data.bankOwner}님
            </Text>
            의 예치금
          </Text>
          <Text size={24} weight={600} lineHeight={34} color="primary_5">
            {depositAccount.data.balance.toLocaleString()}원
          </Text>
        </UserAccountInfo>
        <AlignCenterItem $gap={8}>
          <Button type="secondary" size="small" block={true} href="/myPage/account/withdrawal">
            출금하기
          </Button>
          <Button type="primary" size="small" block={true} href="/myPage/account/deposit">
            충전하기
          </Button>
        </AlignCenterItem>
      </AccountCard>
    </AccountInfoWrap>
  )
}

const AccountInfoWrap = styled.div`
  padding: 16px;
  background-color: ${Color.gray_1};
`

const AccountCard = styled(ColumnItem)`
  gap: 8px;
  padding: 24px;
  border-radius: 16px;
  background-color: ${Color.white};
`

const UserAccountInfo = styled(ColumnItem)`
  margin: 8px 0;
`
